const ENERGY_LABEL_LEADS = {
  title: 'Energimärkning-leads',
  description: 'Översikt över leads för energimärkning',
  searchPlaceholder: 'Sök bland leads …',
  emptyState: 'Inga leads hittades.',
  importButton: 'Importera Excel',
  importError: 'Kunde inte importera filen.',
  importEmpty: 'Filen innehöll inga rader.',
  importSummary: 'Importerade {imported} av {received} rader.',
  importRejected: 'Avvisade rader:',
  importRow: 'Rad {row}',
  importErrors: {
    required: '{field} saknas',
    invalid: '{field} är ogiltigt',
    // more precise than the generic wording, worth its own key
    organizationNumber_invalid: 'Org.nummer måste ha 9 siffror',
  },
  importFields: {
    contactPerson: 'Kontaktperson',
    organizationNumber: 'Org.nummer',
    contactEmail: 'E-post',
    contactPhone: 'Mobil',
    companyName: 'Org. namn',
  },
  assignToMe: 'Tilldela till mig själv',
  assignToMeNeedsEnovaGuid:
    'Din användare saknar Enova-GUID och kan därför inte ta leads.',
  backToList: 'Tillbaka till leads',
  unassigned: 'Ej tilldelad',
  loadError: 'Kunde inte hämta leads.',
  assignError: 'Kunde inte tilldela leaden.',
  notFound: 'Leaden hittades inte.',
  importNotImplemented: 'Excel-import är inte implementerad ännu.',
  commentSaveError: 'Kunde inte spara anteckningen.',
  commentSaved: 'Anteckningen har sparats.',
  daysAgo: '{count} dagar sedan',
  missingAddress: 'Saknar adress',
  deleteConfirmTitle: 'Radera lead',
  deleteConfirmMessage:
    'Är du säker på att du vill radera denna lead? Detta kan inte ångras.',
  deleteError: 'Kunde inte radera leaden.',
  archiveError: 'Kunde inte arkivera leaden.',
  blockError: 'Kunde inte blockera leaden.',
  blockNotYours: 'Endast rådgivaren som ärendet är tilldelat kan blockera det.',
  blockWrongStatus: 'Ärendet kan bara blockeras medan besiktningen pågår.',
  archiveConfirmTitle: 'Arkivera lead',
  archiveConfirmMessage:
    'Är du säker på att du vill arkivera detta ärende? Det markeras som arkiverat och lämnar de öppna ärendena.',
  archiveNotAllowed: 'En slutförd lead kan inte arkiveras.',
  assignWrongStatus:
    'Leaden kan bara tilldelas när status är Formulär ifyllt, Tilldelad rådgivare, Blockerad eller Saknar information.',
  actions: {
    archive: 'Arkivera',
    block: 'Blockera',
    unblock: 'Häv blockering',
  },
  lifecycle: {
    title: 'Livscykel',
    steps: {
      imported: 'Lead importerad',
      created: 'Skapad — formulär skickat till kund',
      formCompleted: 'Kunden klar — klar för rådgivare',
      inspectionStarted: 'Tilldelad rådgivare',
      inspectionCompleted: 'Rådgivare klar',
      completed: 'Energicertifikat utfärdat',
    },
  },
  building: {
    title: 'Byggnad',
    buildingNumber: 'Byggnadsnummer',
    buildingType: 'Byggnadstyp',
    none: 'Ingen byggnad är kopplad till leaden ännu.',
    open: 'Öppna byggnaden',
  },
  energyLabel: {
    title: 'Energideklaration',
    grade: 'Energiklass',
    issued: 'Utfärdad',
    openCertificate: 'Öppna intyget',
    complete: 'Slutför lead',
    completeHelp:
      'Sätter leadet till slutfört och mejlar energideklarationen till kontaktpersonen',
    completeError: 'Kunde inte slutföra leadet.',
  },
  inspection: {
    title: 'Besiktning',
    name: 'Namn',
    date: 'Besiktningsdatum',
    readSubmitted: 'Läs inskickade uppgifter',
    open: 'Öppna besiktningen',
    create: 'Skapa besiktning',
    createAgain: 'Skapa ny besiktning',
    noLead: 'Leadet kunde inte laddas.',
    fixErrorsFirst: 'Rätta de {count} felen i kontrollerna ovan först.',
    createHint:
      'Besiktningen sätts upp från formuläret ovan, med standardvärden där kunden inte har svarat.',
    created: 'Besiktningen har skapats.',
    noBuilding: 'Koppla en byggnad till leadet först.',
    noSubmission: 'Inget inskickat formulär är kopplat till leadet ännu.',
    createError: 'Kunde inte skapa besiktningen.',
    exists: 'En besiktning för detta lead skapades just.',
    filledCount: '{count} värden fylldes i med standardvärden.',
  },
  filters: {
    allOpen: 'Alla öppna',
    waitingCustomer: 'Väntar på kund',
    readyForInspector: 'Klar för rådgivare',
    mine: 'Mina ärenden',
    completed: 'Slutförda',
    stopped: 'Stoppade',
    archived: 'Arkiverade',
  },
  columns: {
    contactPerson: 'Kontaktperson',
    organizationNumber: 'Organisationsnummer',
    address: 'Adress',
    status: 'Status',
    consultant: 'Rådgivare',
    created: 'Skapad',
    actions: 'Åtgärd',
  },
  reminder: {
    send: 'Skicka påminnelse',
    sent: 'Påminnelse skickad',
    help: 'Skickar formulärlänken igen med samma deadline',
    noDeadline:
      'Leaden har ingen deadline ännu — skicka första aviseringen först',
    error: 'Kunde inte skicka påminnelsen.',
  },
  status: {
    imported: 'Importerad',
    created: 'Skapad',
    formCompleted: 'Formulär ifyllt',
    inspectionStarted: 'Tilldelad rådgivare',
    inspectionCompleted: 'Besiktning genomförd',
    completed: 'Energimärkning utfärdad',
    blocked: 'Blockerad',
    notEnoughInformation: 'Saknar information',
    cancelled: 'Arkiverad',
    unknown: 'Okänd',
  },
  detail: {
    companyName: 'Företagsnamn',
    internalComment: 'Intern anteckning',
    internalCommentPlaceholder: 'Endast synlig för oss, aldrig för kunden',
    contactSection: 'Kontaktuppgifter',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-post',
    companySection: 'Verksamhet',
    organizationNumber: 'Organisationsnummer',
    streetName: 'Gatunamn',
    houseNumber: 'Husnummer',
    houseLetter: 'Bokstav',
    postalCode: 'Postnummer',
    city: 'Ort',
    mpidsSection: 'Mätpunkts-ID:n',
    noMpids: 'Inga mätpunkts-ID:n registrerade',
    status: 'Status',
    formSection: 'Kundformulär',
    formLink: 'Länk till kunden',
    copyLink: 'Kopiera länk',
    linkCopied: 'Länken har kopierats.',
    formStatus: 'Formulärstatus',
    formNotStarted: 'Inte öppnat ännu',
    formDraft: 'Pågår',
    formSubmitted: 'Inskickat',
  },
};

export default ENERGY_LABEL_LEADS;
